<template lang="pug">
  div.content
    div(ref="tableContent").e-table.table
      div(
      v-if="hasRightFixedCols && data && data.length > 0"
      :style="{'width': `${actionColumnWidth}px`, 'margin-right': `-${marginOnScrollReleased}px`}"
      ).e-table__fixed-right
        div.e-table__fixed-right-patch
        div(:style="{}").e-table__header-wrapper
          table(
            v-if="items && items.data"
            :style="{'margin-left': `-${tableWidth}px`}"
          ).e-table__header
            colgroup
              col(v-if="checkShow" :width="checkboxColumnWidth")
              col(v-for="item, fieldName, itemIndex in fieldsCols" v-if="visibleColumns.indexOf(fieldName) > -1" :width="fieldsCols[fieldName].resizedWidth")
              col(:width="actionColumnWidth" v-if="showActionButtons")
            // fake head
            thead
              tr
                th(v-if="checkShow").is-hide
                  input.checkbox(type="checkbox" id="checkbox-all-fake" v-model="checkAll")
                  label(for="checkbox-all-fake")
                th(v-for="item, fieldName, itemIndex in fieldsCols" v-if="visibleColumns.indexOf(fieldName) > -1").is-hide
                  div.is-hide
                    div.sortable.text() {{ meta.fields[fieldName].label }}
                    div.sortable.arrows(v-if="meta.sort && meta.fields[fieldName].sortable")
                      span.up(:class="meta.sort[fieldName] === 'asc' ? 'active' : ''" v-on:click.prevent="letSort(fieldName, 'asc')")
                      span.down(:class="meta.sort[fieldName] === 'desc' ? 'active' : ''" v-on:click.prevent="letSort(fieldName, 'desc')")
                th(
                v-if="showActionButtons"
                ).is-show
                  div.is-show {{actionColumnTitle}}

        e-perfect-scrollbar(
        :emitTypes="['vue']"
        @ps-scroll-y="scrollTopHandler($event.event)"
        @ps-scroll-x="scrollTopHandler($event.event)"
        :config="{suppressScrollY: false, suppressScrollX: true}"
        ref="tableFixedPS"
        class="fixed-left-scrollbar"
        )
          // fake table
          div.e-table__body-wrapper(
          v-if="data && data.length > 0"
          ref="tableFixed"
          :style="{'max-height': fixedTableRightHeight ? `${fixedTableRightHeight}px` : `auto`}"
          )
            table(:style="{'margin-left': `-${tableWidth}px`}").e-table__body
              colgroup
                col(v-if="checkShow" :width="checkboxColumnWidth")
                col(
                v-for="item, fieldName, itemIndex in fieldsCols"
                v-if="visibleColumns.indexOf(fieldName) > -1"
                :width="fieldsCols[fieldName].resizedWidth + magicChromePixel"
                )
                col(:width="actionColumnWidth" v-if="showActionButtons")
              tbody(
              v-if="data"
              is="transition-group"
              :name="animationActionColumnName"
              )
                template(v-for="(dataValue, dataIndex) in data")
                  tr(
                  v-if="fullWidthTr(dataValue) > 0"
                  :key="dataValue[idKeyName]"
                  :class="trClass(dataValue)"
                  )
                    slot(
                    name="fullWidthTr"
                    :row="dataValue"
                    :colspan="colspan"
                    )
                  tr(
                  v-else
                  :key="dataValue[idKeyName]"
                  :class="trClass(dataValue)"
                  )
                    td(:class="$parent.checkedItems && $parent.checkedItems.indexOf(dataValue.id) > -1 ? 'checked' : 'not-checked'" v-if="checkShow")
                      input.checkbox(type="checkbox" :id="'checkbox' + dataIndex" v-model="$parent.checkedItems" :value="dataValue.id")
                      label(:for="'checkbox' + dataIndex")
                    td(
                    v-for="item, fieldName, itemIndex in fieldsCols"
                    :key='itemIndex'
                    v-if="visibleColumns.indexOf(fieldName) > -1"
                    )
                      //div
                        p {{visibleColumns}}
                        p {{dataValue}}
                        p fieldName={{fieldName}} itemIndex={{itemIndex}}
                      template(v-if="$scopedSlots[fieldName]")
                        slot(
                        :name="fieldName"
                        :row="dataValue"
                        :toggleRow="toggleRow"
                        :isExpanded="openedRows.indexOf(dataValue[idKeyName]) > -1"
                        )
                      div(v-else-if="typeof dataValue[fieldName] === 'boolean'") {{dataValue[fieldName] ? 'Да' : 'Нет'}}
                      div(v-else-if="typeof(dataValue[fieldName]) !== 'object'" v-html="dataValue[fieldName]")
                      div(v-else-if="Array.isArray(dataValue[fieldName])" v-e-array-as-line="dataValue[fieldName]")
                      div(v-else-if="dataValue[fieldName] && fields[fieldName].path") {{ dataValue[fieldName][fields[fieldName].path] }}
                      div(v-else-if="dataValue[fieldName] && dataValue[fieldName].name") {{ dataValue[fieldName].name }}
                    // real buttons
                    td(v-if="showActionButtons")
                      div(v-if="$scopedSlots['actionButtons']").is-show
                        slot(
                        name="actionButtons"
                        :row="dataValue"
                        :acceptEdit="userCanEdit"
                        :acceptDelete="userCanDelete"
                        :acceptCreate="userCanCreate"
                        :displayViewButton="displayViewButton"
                        )
                      div(v-else).buttons.is-show
                        button.row-edit(
                        v-if="displayEditButton"
                        @click="$emit('editItem', dataValue)"
                        ) {{$translate(editRowLabel)}}
                        button.row-view(
                          v-else-if="displayViewButton"
                          @click.stop.prevent="$emit('editItem', dataValue)"
                        ) {{$translate(viewRowLabel)}}
                        button.row-expand(
                        v-if="displayExpandButton"
                        @click.stop.prevent="toggleRow(dataValue)"
                        :class="{'row-expand__expanded': openedRows.indexOf(dataValue[idKeyName]) > -1}"
                        )
                        button.row-delete(
                        v-if="displayDeleteButton"
                        @click="$emit('deleteItem', dataValue)"
                        )
                  tr(
                  v-if="openedRows.indexOf(dataValue[idKeyName]) > -1"
                  :key="`expanded_${dataValue[idKeyName]}`"
                  :class="trClass(dataValue, true)"
                  ).expanded.fake
                    td(
                    :colspan="colspanExpanded"
                    ).expanded-row
                      slot(
                      name="expandedRow"
                      :row="dataValue"
                      :reFetchOpenedRowData="reFetchOpenedRowData"
                      :loading="openedRowsLoading.indexOf(dataValue[idKeyName]) > -1"
                      )
                    td(v-if="colspanExpanded !== colspan")
                      div.expanded-arrow

                template(v-if="data.length === 0")
                  tr(
                  key="0"
                  )
                    td(:colspan="colspan") {{$translate(this.noDataMsg)}}


      // real table
      div(v-if="items && items.data" ref="tableHeaderWrapper").e-table__header-wrapper
        table(:style="{ 'margin-left': `-${scrollLeft}px`}" ref="tableHeader").e-table__header
          colgroup
            col(v-if="checkShow" :width="checkboxColumnWidth")
            col(v-for="item, fieldName, itemIndex in fieldsCols" v-if="visibleColumns.indexOf(fieldName) > -1" :width="fieldsCols[fieldName].resizedWidth")
            col(:width="actionColumnWidth" v-if="showActionButtons")
          // real head
          thead
            tr
              th(v-if="checkShow")
                input.checkbox(type="checkbox" id="checkbox-all" v-model="checkAll")
                label(for="checkbox-all")

              th(v-for="item, fieldName, itemIndex in fieldsCols" v-if="visibleColumns.indexOf(fieldName) > -1")
                div
                  div.sortable.text {{ meta.fields[fieldName].label }}
                  div.sortable.arrows(v-if="meta.sort && meta.fields[fieldName].sortable")
                    span.up(:class="meta.sort[fieldName] === 'asc' ? 'active' : ''" v-on:click.prevent="letSort(fieldName, 'asc')")
                    span.down(:class="meta.sort[fieldName] === 'desc' ? 'active' : ''" v-on:click.prevent="letSort(fieldName, 'desc')")
              th(
              v-if="showActionButtons"
              )
                div {{actionColumnTitle}}

      e-perfect-scrollbar(
      :emitTypes="['vue']"
      @ps-scroll-y="scrollLeftHandler($event.event)"
      @ps-scroll-x="scrollLeftHandler($event.event)"
      :config="{suppressScrollY: false, suppressScrollX: false}"
      ref="tablePS"
      class="real-table-scrollbar"
      :updateStreamName="scrollUpdateStreamName"
      )
        div(
        v-if="items"
        :style="{'max-height': fixedTableHeight ? `${fixedTableHeight}px` : ``, 'margin-top': `-${scrollTop}px`}"
        ref="table"
        ).e-table__body-wrapper
          table.e-table__body
            colgroup
              col(v-if="checkShow" :width="checkboxColumnWidth")
              col(v-for="(item, fieldName, itemIndex) in fieldsCols" v-if="visibleColumns.indexOf(fieldName) > -1" :width="fieldsCols[fieldName].resizedWidth")
              col(:width="actionColumnWidth" v-if="showActionButtons")
            tbody(
            v-if="data"
            is="transition-group"
            :name="animationName"
            )
              template(v-for="(dataValue, dataIndex) in data")
                tr(
                v-if="fullWidthTr(dataValue) > 0"
                :key="dataValue[idKeyName]"
                :class="trClass(dataValue)"
                )
                  slot(
                  name="fullWidthTr"
                  :row="dataValue"
                  :colspan="colspan"
                  )
                tr(
                v-else
                :key="dataValue[idKeyName]"
                :class="trClass(dataValue)"
                @click="$emit('rowClick', dataValue)"
                )
                  td(:class="$parent.checkedItems && $parent.checkedItems.indexOf(dataValue.id) > -1 ? 'checked' : 'not-checked'" v-if="checkShow")
                    input.checkbox(type="checkbox" :id="'checkbox' + dataIndex" v-model="$parent.checkedItems" :value="dataValue.id")
                    label(:for="'checkbox' + dataIndex")
                  td(
                  v-for="(item, fieldName, itemIndex) in fieldsCols"
                  :key='itemIndex'
                  v-if="visibleColumns.indexOf(fieldName) > -1"
                  )
                    template(v-if="$scopedSlots[fieldName]")
                      slot(
                      :name="fieldName"
                      :row="dataValue"
                      :rowIndex="dataIndex"
                      :toggleRow="toggleRow"
                      :isExpanded="openedRows.indexOf(dataValue[idKeyName]) > -1"
                      )
                    div(v-else-if="typeof dataValue[fieldName] === 'boolean'") {{dataValue[fieldName] ? 'Да' : 'Нет'}}
                    div(v-else-if="typeof(dataValue[fieldName]) !== 'object'" v-html="dataValue[fieldName]")
                    div(v-else-if="Array.isArray(dataValue[fieldName])" v-e-array-as-line="dataValue[fieldName]")
                    div(v-else-if="dataValue[fieldName] && fields[fieldName].path") {{ dataValue[fieldName][fields[fieldName].path] }}
                    div(v-else-if="dataValue[fieldName] && dataValue[fieldName].name") {{ dataValue[fieldName].name }}
                  td(v-if="showActionButtons").is-hide
                    template(v-if="$scopedSlots['actionButtons']")
                      slot(
                      name="actionButtons"
                      :row="dataValue"
                      :rowIndex="dataIndex"
                      :acceptEdit="userCanEdit"
                      :acceptDelete="userCanDelete"
                      :acceptCreate="userCanCreate"
                      :displayViewButton="displayViewButton"
                      )
                    div(v-else).buttons
                      button.row-edit(
                      v-if="displayEditButton"
                      @click.stop.prevent="$emit('editItem', dataValue)"
                      ) {{$translate(editRowLabel)}}
                      button.row-view(
                        v-else-if="displayViewButton"
                        @click.stop.prevent="$emit('editItem', dataValue)"
                      ) {{$translate(viewRowLabel)}}
                      button.row-expand(
                      v-if="displayExpandButton"
                      @click.stop.prevent="toggleRow(dataValue)"
                      :class="{'row-expand__expanded': openedRows.indexOf(dataValue[idKeyName]) > -1}"
                      )
                      button.row-delete(
                      v-if="displayDeleteButton"
                      @click.stop.prevent="$emit('deleteItem', dataValue)"
                      )
                tr(
                v-if="openedRows.indexOf(dataValue[idKeyName]) > -1"
                :key="`expanded_${dataValue[idKeyName]}`"
                :class="trClass(dataValue, true)"
                ).expanded
                  td(
                  :colspan="colspanExpanded"
                  ).expanded-row
                    slot(
                    name="expandedRow"
                    :row="dataValue"
                    :reFetchOpenedRowData="reFetchOpenedRowData"
                    :loading="openedRowsLoading.indexOf(dataValue[idKeyName]) > -1"
                    )
                  td(v-if="colspanExpanded !== colspan")
                    div.expanded-arrow

              template(v-if="data.length === 0")
                tr(
                key="0"
                )
                  td(:colspan="colspan") {{$translate(this.noDataMsg)}}

    div.footer-nav(v-if="showFooter")
      div.actions-filter-panel
        slot(name="tableLeftFilterPanel")
        button(
        v-if="showDownloadButton"
        @click="$emit('download')"
        ).actions-filter-panel__button.default.download {{$translate('Скачать')}}

      e-pagination(v-if="showPagination"
      :auto="autoRoutingOnPagination"
      :pageCount="meta.pageCount"
      :currentPage="meta.currentPage"
      :totalCount="meta.totalCount"
      :perPage="meta.perPage"
      :paginateMethod="paginateMethod"
      @paginate="onPaginate"
      )

</template>

<script>
  import {PERMS} from '../../config/permissions.js'
  import browser from 'browser-detect'

  const DEBUG_ENABLE = false

  export default {
    name: 'e-table',
    data () {
      this.fetchOpenedSettings = {}
      return {
        // get from $parent
        /* checks: [], */
        columnsarr: [],
        currentSort: '',
        currentPaginate: {},
        checkAll: false,
        scrollLeft: 0,
        scrollTop: 0,

        windowWidth: 0,
        windowHeight: 0,
        headerHeight: 100,
        headerOffsetLeft: 0,
        headerOffsetRight: 0,
        tableContentWidth: 0,

        openedRows: [],
        openedRowsLoading: []
      }
    },
    props: {
      customVisibleColumns: {
        type: Array,
        default: () => []
      },
      showFooter: {
        type: Boolean,
        default: true
      },
      tableWrapperClass: {
        type: String,
        default: 'table tscroll'
      },
      showCheckbox: {
        type: Boolean,
        default: true
      },
      showDeleteButton: {
        type: Boolean,
        default: true
      },
      showEditButton: {
        type: Boolean,
        default: true
      },
      items: null,
      autoRoutingOnSort: {
        type: Boolean,
        default: true
      },
      showPagination: {
        type: Boolean,
        default: true
      },
      autoRoutingOnPagination: {
        type: Boolean,
        default: true
      },
      showDownloadButton: {
        type: Boolean,
        default: false
      },
      /* // Fixed columns table setting */
      checkboxColumnWidth: {
        type: [Number, String],
        default: 50
      },
      actionColumnWidth: {
        type: [Number, String],
        default: 130
      },
      defaultColumnWidth: {
        type: [Number, String],
        default: 270
      },
      /* enable/desibel js table height calculation */
      calculateTableHeight: {
        type: Boolean,
        default: true
      },
      /* get offset */
      contentSelector: {
        type: String,
        default: '.content'
      },
      /* get height */
      footerSelector: {
        type: String,
        default: '.content .footer-nav'
      },
      /* floating margin offset */
      marginBottom: {
        type: Number,
        default: 5
      },
      /* height of table bottom scroll */
      tableBottomScrollHeight: {
        type: Number,
        default: 0 // 15 <-- if not perfect scrollbar
      },
      fixedColumns: {
        type: Array,
        default: function () {
          return []
        }
      },
      /* рассчитывать ширину колонок с учетом маржина? */
      accurateColumnWidth: {
        type: Boolean,
        default: true
      },
      tableHeight: {
        type: [Number, String],
        default: 0
      },
      tableHeightCoef: {
        type: Number,
        default: 1
      },
      tableHeightRight: {
        type: [Number, String],
        default: 0
      },
      tableId: {
        type: String,
        default: function () {
          return this.$route.name
        }
      },
      fullWidthTr: {
        type: Function,
        // eslint-disable-next-line
        default: function (row) {
          return 0
        }
      },
      trClass: {
        type: Function,
        // eslint-disable-next-line
        default: function (row, isExpanded) {
          return null
        }
      },
      scrollUpdateStreamName: {
        type: String,
        default: null
      },
      paginateMethod: String,
      animationName: {
        type: String,
        default: 'e-table'
      },
      animationActionColumnName: {
        type: String,
        default: 'e-table'
      },
      idKeyName: {
        type: String,
        default: 'id'
      },
      scrollToTopOnRouteChange: {
        type: Boolean,
        default: true
      },
      fetchOpenedRowData: {
        type: Function,
        // eslint-disable-next-line
        default: (row, sort, paginate) => Promise.resolve(true)
      },
      editRowLabel: {
        type: String,
        default: null
      },
      viewRowLabel: {
        type: String,
        default: 'Открыть'
      },
      actionColumnTitle: {
        type: String,
        default: ''
      },
      noDataMessage: {
        type: String,
        default: null
      }
    },
    watch: {
      data: 'update',
      checkAll: 'onCheckAll',
      '$route': 'setFiltersFromUrl'
    },
    methods: {
      reFetchOpenedRowData: async function (row, {sort, paginate}) {
        try {
          this.openedRowsLoading.push(row[this.idKeyName])
          this.fetchOpenedSettings[row[this.idKeyName]] = {
            sort,
            paginate
          }
          await this.fetchOpenedRowData(row, sort, paginate)
        } catch (er) {
          this.$e.errorBox(er)
        } finally {
          this.openedRowsLoading = this.openedRowsLoading.filter(id => id != row[this.idKeyName])
          this.updateScroll()
        }
      },
      toggleRow (row) {
        if (this.openedRows.indexOf(row[this.idKeyName]) > -1) {
          this.closeRow(row)
        } else {
          this.openRow(row)
        }
      },
      openRow: async function (row) {
        this.openedRows.push(row[this.idKeyName])
        try {
          this.openedRowsLoading.push(row[this.idKeyName])
          const prev = this.fetchOpenedSettings[row[this.idKeyName]] || {}
          await this.fetchOpenedRowData(row, prev.sort, prev.paginate)
        } catch (er) {
          this.$e.errorBox(er)
        } finally {
          this.openedRowsLoading = this.openedRowsLoading.filter(id => id != row[this.idKeyName])
          this.updateScroll()
        }
      },
      closeRow (row) {
        this.openedRows = this.openedRows.filter(id => id != row[this.idKeyName])
        this.updateScroll()
      },
      updateScroll (delay = 50) {
        console.log('updateScroll')
        setTimeout(() => {
          if (this.$refs.tablePS) {
            this.$refs.tablePS.update()
          }
          if (this.$refs.tableFixedPS) {
            this.$refs.tableFixedPS.update()
          }
        }, delay)
      },
      setFiltersFromUrl (to, prev) {
        let q = Object.assign({}, this.$route.query)
        this.query = q.q
        this.updateTableState()
        this.forceResize()
        if (this.scrollToTopOnRouteChange === true) {
          this.scrollTableToTop(to, prev)
        }
        this.reSyncScrollPositions()
      },
      scrollTableToTop (to, prev = {name: null, query: {}}) {
        if (!prev.name || prev.name === to.name) {
          this.$nextTick(() => {
            if (this.$refs.tablePS) {
              this.$refs.tablePS.setScrollTop(0)
            }
            if (this.$refs.tableFixedPS) {
              this.$refs.tableFixedPS.setScrollTop(0)
            }
          })
        }
      },
      reSyncScrollPositions () {
        this.$nextTick(() => {
          if (this.$refs.tableFixedPS && this.$refs.tableFixedPS) {
            this.$refs.tableFixedPS.setScrollTop(
              this.$refs.tablePS.getScrollTop()
            )
          }
        })
      },
      /* on select all */
      onCheckAll () {
        this.checking(this.checkAll)
      },
      updateTableState () {
        // console.log(this.visibleColumns)
        if (this.savedVisibleColumns === null) {
          let toSave = []
          let fields = this.fields || {}
          for (let name in fields) {
            toSave.push(name)
          }
          if (toSave.length > 0) {
            this.$sharedServices.store.commit('tableState', {
              id: this.tableId,
              param: 'visibleColumns',
              data: toSave
            })
          }
        }
        if (Object.keys(this.meta).length > 0) {
          this.$sharedServices.store.commit('tableState', {
            id: this.tableId,
            param: 'meta',
            data: this.meta
          })
        }
      },
      /* Чекаем поля */
      checking (isChecked) {
        this.$parent.checkedItems = null
        this.$parent.checkedItems = []
        if (isChecked) {
          this.data.forEach(o => {
            this.$parent.checkedItems.push(o.id)
          })
        }
      },
      /* Меняем сортировку */
      letSort (item, direct) {
        if (this.meta.sort) {
          let key = Object.keys(this.meta.sort)[0]
          if (key !== item) {
            key = item
          }
          if (direct === 'desc') key = `-${key}`
          this.currentSort = key
          this.$emit('sort', key)
          this.sortAndPaginate()
          if (this.autoRoutingOnSort) {
            let newRoute = {
              name: this.$route.name,
              params: Object.assign({}, this.$route.params || {}),
              query: Object.assign({}, this.$route.query || {})
            }
            newRoute.query['sort'] = key
            this.$router.push(newRoute)
          }
          // this.changeData(this.meta.perPage, this.meta.currentPage, key);
        }
      },
      onPaginate (evt) {
        this.currentPaginate = evt
        this.$emit('paginate', evt)
        this.sortAndPaginate()
      },
      sortAndPaginate () {
        this.$emit('sortAndPaginate', {
          paginate: this.currentPaginate,
          sort: this.currentSort
        })
      },
      update () {
        this.checkAll = false
      },
      /**
       * scroll main table
       * @param $event
       */
      scrollLeftHandler ($event) {
        let el = $event.srcElement || $event.target
        this.scrollLeft = el.scrollLeft
        if (this.$refs.tableFixedPS) {
          this.$refs.tableFixedPS.setScrollTop(el.scrollTop)
        } else if (this.$refs.tableFixed) {
          this.$refs.tableFixed.scrollTop = el.scrollTop
        }
      },
      /**
       * scroll action buttons columns
       * @param $event
       */
      scrollTopHandler ($event) {
        let el = $event.srcElement || $event.target
        if (this.$refs.tablePS) {
          this.$refs.tablePS.setScrollTop(el.scrollTop)
        } else if (this.$refs.table) {
          this.$refs.table.scrollTop = el.scrollTop
        }
      },
      forceResize () {
        this.windowHeight = null
        this.windowHeight = null
        this.resizeListener()
      },
      resizeListener () {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
        if (this.$refs.tableHeader && this.$refs.tableHeader.getBoundingClientRect()) {
          let rect = this.$refs.tableHeader.getBoundingClientRect()
          let wrapperRect = this.$refs.tableHeaderWrapper.getBoundingClientRect()
          this.headerHeight = +rect.height
          this.headerOffsetLeft = +wrapperRect.left
          this.headerOffsetRight = this.windowWidth - wrapperRect.right
        } else {
          setTimeout(() => {
            this.resizeListener()
          }, 100)
        }
        this.calcContentWidth()
      },
      initEventListeners () {
        window.addEventListener('resize', this.resizeListener)
        this.resizeListener()
        this.subs = this.$emitter.listen('heightChanged', ({name, el}) => {
          // console.log({name, el})
          this.forceResize()
        })
      },
      calcContentWidth () {
        if (this.$refs.tableContent) {
          this.tableContentWidth = this.$refs.tableContent.clientWidth
        }
      }
    },
    destroyed () {
      window.removeEventListener('resize', this.resizeListener)
      if (this.subs) {
        this.subs.unsubscribe()
      }
    },
    created () {
      this.updateTableState()
    },
    mounted () {
      this.initEventListeners()
      this.$nextTick().then(() => {
        this.resizeListener()
      })
      // TODO cresize on slots add/remove
      // deffered recheck of mount all slots
      setTimeout(() => {
        this.resizeListener()
      }, 500)
    },
    updated () {
      this.calcContentWidth()
    },
    computed: {
      // хром скрытую таблицу переодически делает
      // чуть меньше, поэтому чуть чуть ее увеличиваем
      magicChromePixel () {
        if (this.isChrome) {
          return 0.2
        } else {
          return 0
        }
      },
      browser () {
        return browser()
      },
      // https://github.com/KennethanCeyer/browser-detect/blob/master/src/definitions.ts
      isChrome () {
        return this.browser.name === 'chrome' || this.browser.name === 'yandexbrowser'
      },
      showActionButtons () {
        if (this.displayDeleteButton || this.displayEditButton || this.displayExpandButton || this.displayViewButton) {
          return true
        }
        return false
      },
      displayExpandButton () {
        return this.$scopedSlots.expandedRow
      },
      displayDeleteButton () {
        return this.showDeleteButton && this.userCanDelete
      },
      displayEditButton () {
        return this.showEditButton && this.userCanEdit
      },
      // отображается если не отключена картчока редактирвоания
      // но у пользователя нет прав на редактирвоание
      displayViewButton () {
        return this.showEditButton && this.userCanView
      },
      userCanDelete () {
        return this.$sharedServices.store.getters.userCan(PERMS.DELETE, {route: this.$route})
      },
      userCanView () {
        return this.$sharedServices.store.getters.userCan(PERMS.VIEW, {route: this.$route})
      },
      userCanEdit () {
        return this.$sharedServices.store.getters.userCan(PERMS.EDIT, {route: this.$route})
      },
      userCanCreate () {
        return this.$sharedServices.store.getters.userCan(PERMS.CREATE, {route: this.$route})
      },
      hasRightFixedCols () {
        return this.showActionButtons
      },
      calcTableHeight () {
        if (this.calculateTableHeight === false) {
          return 0
        }
        let bodyHeight = this.windowHeight
        let foreignElementsHeight = 0
        let headerHeight = this.headerHeight || 150
        let nodes = document.querySelectorAll(this.contentSelector)
        if (nodes && nodes.length > 0) {
          // get first content block height
          foreignElementsHeight += +nodes[0].getBoundingClientRect().top
        }
        nodes = document.querySelectorAll(this.footerSelector)
        if (nodes && nodes.length > 0) {
          // get footer height
          foreignElementsHeight += +nodes[0].getBoundingClientRect().height
        }
        DEBUG_ENABLE && console.log('T header=' + headerHeight + ' foreignElementsHeight' + foreignElementsHeight)

        return this.tableHeightCoef * (bodyHeight - foreignElementsHeight - headerHeight - this.tableBottomScrollHeight - this.marginBottom)
      },
      fixedTableRightHeight () {
        if (this.calcTableHeight > 0) {
          return this.calcTableHeight
        }
        return this.tableHeightRight
      },
      fixedTableHeight () {
        let h = this.calcTableHeight || this.tableHeight
        if (h) {
          h = +h + (+this.tableBottomScrollHeight)
        }
        return h
      },
      bodyWrapperOverflow () {
        return 'scroll'
      },
      marginOnScrollReleased () {
        return 0 // 15
      },
      fieldsCols () {
        let fields = this.fields
        let visibleCols = this.visibleColumns || []
        let colsWidthSum = 0
        visibleCols.forEach(name => {
          if (fields.hasOwnProperty(name)) {
            if (!fields[name].hasOwnProperty('width')) {
              fields[name].width = this.defaultColumnWidth
              colsWidthSum = +colsWidthSum + (+this.defaultColumnWidth)
            } else {
              colsWidthSum = +colsWidthSum + (+fields[name].width)
            }
          }
        })
        // resize cols if table width 100% and cols rows < 100%
        let bodyWidth = this.windowWidth
        if (this.accurateColumnWidth === true) {
          let offset = this.headerOffsetLeft + this.headerOffsetRight
          bodyWidth = Math.ceil(bodyWidth - offset)
        }
        DEBUG_ENABLE && console.log('bodyWidth', bodyWidth, this.$refs.tableContent)

        if (this.checkShow) {
          bodyWidth = bodyWidth - this.checkboxColumnWidth
        }
        if (this.showActionButtons) {
          bodyWidth = bodyWidth - this.actionColumnWidth
        }
        let widthResizeQ = 1
        if (bodyWidth > colsWidthSum) {
          widthResizeQ = bodyWidth / colsWidthSum
        }
        let divisionFieldName = null
        let colWSum = 0
        visibleCols.forEach(name => {
          if (fields.hasOwnProperty(name)) {
            fields[name].resizedWidth = Math.ceil(fields[name].width * widthResizeQ)
            colWSum = colWSum + fields[name].resizedWidth
            divisionFieldName = divisionFieldName || name
          }
        })
        if (widthResizeQ > 1 && fields[divisionFieldName]) {
          // в ff колонки в таблице чуть меньше
          const magicFFPixel = this.isChrome ? 1 : 2
          const division = colWSum - bodyWidth
          DEBUG_ENABLE && console.log(+fields[divisionFieldName].resizedWidth)
          fields[divisionFieldName].resizedWidth = fields[divisionFieldName].resizedWidth - division - magicFFPixel
          DEBUG_ENABLE && console.log('widthResizeQ', widthResizeQ, division, +fields[divisionFieldName].resizedWidth)
        }
        return fields
      },
      tableWidth () {
        let fieldsCols = this.fieldsCols
        let visibleCols = this.visibleColumns
        let width = 0
        visibleCols.forEach(fieldName => {
          // dont summary fixed columns
          if (this.fixedColumns.indexOf(fieldName) === -1) {
            width = width + (+fieldsCols[fieldName].resizedWidth)
          } else {
            console.log('fixedColumns method doesnt support')
          }
        })
        if (this.checkShow) {
          width = width + (+this.checkboxColumnWidth)
        }
        // dont summary fixed columns
        /*
        if (this.showActionButtons) {
          width = width + (+this.actionColumnWidth)
        }
        */
        return width
      },
      colspanExpanded () {
        if (this.showActionButtons) {
          return this.colspan - 1
        }
        return this.colspan
      },
      colspan () {
        let colspan = this.visibleColumns.length
        if (this.checkShow) {
          colspan++
        }
        if (this.showActionButtons) {
          colspan++
        }
        return colspan
      },
      data () {
        if (this.items && this.items.data) {
          return this.items.data
        }
        return []
      },
      meta () {
        if (this.items && this.items._meta) {
          return this.items._meta
        }
        return {}
      },
      noDataMsg () {
        if (this.noDataMessage) {
          return this.noDataMessage
        }
        if (this.itemsDataHasValidationError) {
          return 'Из-за неверно заполненных полей, не удалось обработать запрос'
        }
        return 'Ничего не найдено...'
      },
      itemsDataHasValidationError () {
        return this.items && this.items.errors && this.items.errors.length
      },
      fields () {
        if (this?.items?._meta?.fields) {
          return this.items._meta.fields
        }
        if (this.itemsDataHasValidationError) {
          console.error(new Error('Empty fields, check response format'))
        }
        return {}
      },
      savedVisibleColumns () {
        return this.$sharedServices.store.getters.tableState(this.tableId, 'visibleColumns')
      },
      /* Получаем видимые колонки */
      visibleColumns () {
        return this.customVisibleColumns.length ? this.customVisibleColumns : this.$sharedServices.store.getters.tableState(this.tableId, 'visibleColumns') || this.allColumns
      },
      allColumns () {
        let cols = []
        if (this?.items?._meta?.fields) {
          for (let fName in this.items._meta.fields) {
            cols.push(fName)
          }
        }
        return cols
      },
      checkShow () {
        return this.showCheckbox
      }
    }
  }
</script>
